import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { signup, signInWithGoogle } from '../helpers/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../css/signup.css'

export default class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            email: '',
            password: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.googleSignIn = this.googleSignIn.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        this.setState({ error: '' });
        try {
            await signup(this.state.email, this.state.password);
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    async googleSignIn() {
        try {
            await signInWithGoogle();
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    render() {
        return (
            <div class="mainPageContainer">
                <div class="formContainer">
                    <form onSubmit={this.handleSubmit}>
                        <h1>Sign Up to
                           <Link style={{ textDecoration: 'none', color: 'white', paddingLeft: '10px' }} to="/">AREA 52</Link>
                        </h1>
                        <p>Fill in the form below to create an account.</p>
                        <div class="formInputs">

                                <input placeholder="Email" name="email" type="email" onChange={this.handleChange} value={this.state.email}></input>
                                <input placeholder="Password" name="password" onChange={this.handleChange} value={this.state.password} type="password"></input>

                                {this.state.error ? <p>{this.state.error}</p> : null}
                                <span onClick={this.handleSubmit} type="submit" class="formButtons">Sign up</span>
                        </div>
                            <p> or sign in with</p>
                            <span class="googleButton" onClick={this.googleSignIn} >
                                <FontAwesomeIcon icon={['fab', 'google']} />
                            </span>
                            <p>Already an AREA 52 Member? <Link to="/login">Login</Link></p>
                    </form>
                </div>
                </div>
        )
    }
}